import ReactUploadSelf from '@jswork/react-upload-self';
import ReactFadeImage from '@jswork/react-fade-image';
import styled from 'styled-components';
import ImageIcon from 'common/components/ImageIcon';
import { useRef } from 'react';

const Container = styled.div`
  height: 100%;
  width: 100%;
  .react-upload-self {
    width: 100%;
    height: 100%;
    .is-action {
      line-height: 1.6;
    }
  }
`;

const VideoContainer = styled.div`
  position: relative;
  &,
  video {
    width: 100%;
    height: 100%;
  }

  video {
    width: 100%;
    height: 100%;
    position: absolute;
    object-fit: cover;
    left: 0;
    top: 0;
    //z-index: 2;
  }

  .is-icon {
    background: #eee;
    padding: 20px;
    border-radius: 100px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:active {
      opacity: 0.8;
    }
  }
`;

const SUPPORT_MEDIAS = ['image', 'video'];
export default props => {
  const { type, ...extProps } = props;
  const videoRef = useRef(null);
  const template = ({ file, url }) => {
    return (
      <nx.$rc.rsm virtual={true} items={SUPPORT_MEDIAS} value={type}>
        <ReactFadeImage className="is-scaleable is-image" src={url} />
        <VideoContainer onClick={() => videoRef.current.pause()}>
          <View
            onClick={e => {
              e.stopPropagation();
              const el = videoRef.current;
              const playing = !!(
                el.currentTime > 0 &&
                !el.paused &&
                !el.ended &&
                el.readyState > 2
              );
              playing ? el.pause() : el.play();
            }}
            plugin="transform-center:xy"
            z={2}
            className="is-icon">
            <ImageIcon size={20} value={'ic_video_grey@2x'} />
          </View>
          <video ref={videoRef} src={url} />
        </VideoContainer>
      </nx.$rc.rsm>
    );
  };

  return (
    <Container>
      <ReactUploadSelf template={template} {...extProps} />
    </Container>
  );
};
